import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { useParams, useLocation, useHistory } from "react-router-dom";
import _, { cloneDeep } from "lodash";
import { v4 as uuidv4 } from "uuid";
import {
  getOrganizationId,
  toastError,
  toastSuccess,
} from "../../../../../utils";
import {
  addPortDistanceToOperations,
  addPortDistanceToSelectedFleet,
  calculationValidation,
  convertPortOperationToDistanceString,
  fleetWithCalculatorDataMapping,
  placeAddedOperation,
} from "../../dataMapping";
import {
  initialCreatePortOperation,
  termsCoEfficientTable,
} from "../../../../../constants";
import { initialContractFields, initialVesselContractFields } from "../../Contracts";
import { useSavedContractsStore } from "../state/useSavedContractsStore";
import {
  getEstimateContractByIdApi,
  updatePortDistanceForContractApi,
  resetPortDistanceForContractApi,
  savePortDistanceApi,
  estimateContractcargoPriceApi,
  estimateContractcargoPriceDetailedApi,
  updateEstimateCostApi,
  deleteCargoFromEstimateByIdApi,
  addCargoForEstimateApi,
  createEstimateContractApi,
  updateEstimateCargoApi,
  updateVesselContractApi,
} from "../services/savedContractsApi";

export function useSavedContractsController(props = {}) {
  const {
    setIsFullScreen = () => {},
    id: propId = "",
    setLoader = () => {},
    loader = false,
  } = props;

  const { id: routeId = "" } = useParams();
  const id = propId || routeId;
  const location = useLocation();
  const history = useHistory();
  const organizationId = getOrganizationId();

  const isViewOnly =
    window.location.pathname.includes("/saved-actual-contracts/") ||
    propId !== "" ||
    false;

  const store = useSavedContractsStore();
  const {
    calculatorData,
    setCalculatorData,
    selectedVessels,
    setSelectedVessels,
    syncBunker,
    setSyncBunker,
    isOverride,
    setIsOverride,
    portDistanceResponse,
    setPortDistanceResponse,
    realPortDistanceResponse,
    setRealPortDistanceResponse,
    portDistancePayloadResponse,
    setPortDistancePayloadResponse,
  } = store;

  const stateRef = useRef(store);
  stateRef.current = store;

  const fetchPortDistance = useRef(true);
  const swipeableActions = useRef(null);

  const [inputValue, setInputValue] = useState("");
  const [prevAttachments, setPrevAttachments] = useState({
    attachments: [],
    textContract: "",
  });
  const [cargoTextContract, setCargoTextContract] = useState(null);
  const [vesselTextContract, setVesselTextContract] = useState(null);
  const [rawEstimateContract, setRawEstimateContract] = useState({});
  const [cargoFormData, setCargoFormData] = useState(initialContractFields);
  const [vesselFormData, setVesselFormData] = useState(initialVesselContractFields);
  const [estimationCopyModelOpen, setEstimationCopyModelOpen] = useState(false);
  const [editCargoContractModelOpen, setEditCargoContractModelOpen] = useState(false);
  const [editVesselContractModelOpen, setEditVesselContractModelOpen] = useState(false);
  const [supplyModal, setSupplyModal] = useState(false);
  const [openAddOperation, setOpenAddOperation] = useState(false);
  const [splitHireModal, setSplitHireModal] = useState(false);
  const [showExpensesModal, setShowExpensesModal] = useState(false);
  const [cargoAttachments, setCargoAttachments] = useState([]);
  const [vesselAttachments, setVesselAttachments] = useState([]);
  const [openAddOperationIndex, setOpenAddOperationindex] = useState(false);
  const [IsEditable, setIsEditable] = useState(false);
  const [isInitialLoad, setIsInitialLoad] = useState(false);
  const [isClosed, setIsClosed] = useState(false);
  const [activeTab, setActiveTab] = useState(0);

  const [fleetCheckbox, setFleetCheckbox] = useState({
    ballest: { 1: true, 2: true, 3: true, 4: true },
    laden: { 1: true, 2: true, 3: true, 4: true },
  });

  const handleTabChange = (index) => {
    setActiveTab(index);
  };

  const handleSwipeChange = (index) => {
    setActiveTab(index);
  };

  useEffect(() => {
    if (swipeableActions.current) {
      setTimeout(() => {
        if (swipeableActions.current) {
          swipeableActions.current.updateHeight();
        }
      }, 100);
    }
  }, [calculatorData.portOperation, activeTab]);

  const onChangeClientQuery = (e) => {
    const { name = "", value = "" } = e.target || {};
    setCalculatorData({
      ...calculatorData,
      clientQuery: {
        ...calculatorData.clientQuery,
        [name]: value,
      },
    });
  };

  const onFetchAndSetIntitalPortDistance = useCallback(
    (propCalculator) => {
      if (!fetchPortDistance.current) return Promise.resolve({});
      let updatedCalculatorData = { ...propCalculator };
      const { getPortDistanceString, routeList } =
        convertPortOperationToDistanceString(updatedCalculatorData);
      setLoader(true, "Calculating port distances...");

      return new Promise((resolve) => {
        const { clientQuery = {} } = updatedCalculatorData;
        const {
          eca = false,
          hra = false,
          jwc = false,
          suez = false,
          panama = false,
          singapore = false,
        } = clientQuery;
        const portDataObj = {
          eca,
          hra,
          jwc,
          suez,
          panama,
          singapore,
          routeOverride: false,
          routeList: routeList,
          portList: getPortDistanceString,
          contractId: id,
          queryId: updatedCalculatorData?.clientQuery?._id,
          getGeometry: false,
        };
        updatePortDistanceForContractApi(portDataObj)
          .then((res) => {
            setLoader(false);
            fetchPortDistance.current = false;
            setPortDistanceResponse(res.data);
            setRealPortDistanceResponse(res?.realData);
            setPortDistancePayloadResponse(res?.payload);
            resolve(res);
          })
          .catch((err) => {
            setLoader(false);
            resolve({});
            toastError(err?.data?.message || "Something went wrong");
          });
      });
    },
    [id, setLoader, setPortDistanceResponse, setRealPortDistanceResponse, setPortDistancePayloadResponse]
  );

  const sendCalculatorResponse = useCallback((modifiedData = {}) => {
    return new Promise((resolve) => {
      try {
        if (!modifiedData?.fleetList?.length) {
          return resolve({});
        }

        const updatedCargoList = (modifiedData.cargoList || []).map((cargoDetails = {}) => {
          const cargoDetailObj = cargoDetails.cargoDetails || {};
          const { _id, ...restCargoMainDetails } = cargoDetails;
          return {
            ...restCargoMainDetails,
            cargoDetails: { ...cargoDetailObj },
          };
        });

        const clientQuery = modifiedData.clientQuery || {};
        const {
          _id,
          cargoList: queryCargoList,
          createdUser,
          lastModifiedUser,
          userId,
          calculationFormat,
          __v,
          createdAt,
          updatedAt,
          isCalculate,
          ...restClientQuery
        } = clientQuery;

        const updatedClientQuery = {
          ...restClientQuery,
          cargoList: null,
        };

        const updatedFleetListData = (modifiedData.fleetList || []).map((fleetDetails = {}) => {
          const vesselDetails = fleetDetails?.vessel ? JSON.parse(fleetDetails.vessel) : {};
          const {
            _id: parseVesselId,
            userId: parseVesselUserId,
            createdUser: parseVesselCreatedUser,
            lastModifiedUser: parseVesselModifiedUser,
            vesselExtraDetails,
            __v: parseVessel__v,
            createdAt,
            createdDate,
            lastModifiedDate,
            pattern,
            updatedAt,
            vesselLabel,
            vesselAHL,
            vesselCO2,
            vesselCountry,
            vesselGrabs,
            vesselIceClass,
            vesselIMO,
            vesselLdnConsmMGO1,
            vesselLdnConsmMGO2,
            vesselLightShip,
            vesselMMSI,
            vesselType,
            vesselSource,
            vesselName,
            ...parseVesselDetails
          } = vesselDetails;

          const {
            _id: fleetId,
            vesselId: fleetVesselId,
            createdUser: fleetCreatedUser,
            organizationId: fleetOrgId,
            userId: fleetUserId,
            lastModifiedUser: fleetLastModifiedUser,
            vesselUniqueId = uuidv4(),
            __v: fleet__v,
            ...restFleetDetails
          } = fleetDetails;

          return {
            ...restFleetDetails,
            vessel: JSON.stringify({
              id: vesselUniqueId,
              ...parseVesselDetails,
              system: true,
            }),
            vesselId: vesselUniqueId,
          };
        });

        const updatedCargoExtraDetails = (modifiedData.cargoExtraDetails || []).map(
          (cargoextraDetails = {}) => {
            const extraCargoDetails = cargoextraDetails.cargoDetails || {};
            const { _id, ...restCargoMainDetails } = cargoextraDetails;
            return {
              ...restCargoMainDetails,
              cargoDetails: { ...extraCargoDetails },
            };
          }
        );

        const calculationData = {
          id: id,
          autoSave: modifiedData.autoSave || false,
          cargoExtraDetails: updatedCargoExtraDetails,
          cargoList: updatedCargoList,
          clientQuery: updatedClientQuery,
          fleetList: updatedFleetListData,
        };

        estimateContractcargoPriceApi(calculationData)
          .then((res) => resolve(res))
          .catch((err) => {
            toastError(err?.data?.message || "Something went wrong");
            resolve({});
          });

        estimateContractcargoPriceDetailedApi(calculationData)
          .then((res) => resolve(res))
          .catch((err) => {
            toastError(err?.data?.message || "Something went wrong");
            resolve({});
          });
      } catch (error) {
        toastError("An unexpected error occurred");
        resolve({});
      }
    });
  }, [id]);

  const saveAllResultUpdatedData = useCallback(
    ({ newUpdatedQuery, newUpdatedFleet }) => {
      setLoader(true, "Saving calculation results...");
      updateEstimateCostApi({
        contractId: id,
        newUpdatedQuery,
        newUpdatedFleet,
      })
        .then((res) => {
          setLoader(false);
          if (res?.success) {
            toastSuccess("Calculation updated and saved successfully!");
          }
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message || err?.message || "An error occurred");
        });
    },
    [id, setLoader]
  );

  const onChangeFleetRowSelect = useCallback(
    async (
      fleet = {},
      resultCalculatorData = null,
      changeVessel = false,
      isPortDistanceChanged = false
    ) => {
      const currentState = stateRef.current;
      let updatedCalculatorData = resultCalculatorData || { ...currentState.calculatorData };
      let commencePort = (fleet && fleet.port) || "";
      let fleetFuelType =
        (fleet && fleet.vessel && JSON.parse(fleet.vessel)) || {};
      fleetFuelType = fleetFuelType.fuelType || "TYPE0";
      let portOperation = [...(updatedCalculatorData.portOperation || [])];

      const portToPortOperationResultMap =
        (fleet && fleet.portToPortOperationResultMap) || [];
      portOperation = portOperation.map((operation, index) => {
        const selectedResultMap = portToPortOperationResultMap[index] || {};
        const removeDistanceFromResultMap = ({
          distanceECA = "",
          distanceNormal = "",
          ...rest
        }) => ({ ...rest });

        if (index !== 0) commencePort = (operation && operation.port) || "";
        let isTermExists = termsCoEfficientTable[0];
        if (operation.terms) {
          isTermExists =
            termsCoEfficientTable.find((item) => item.label === operation.terms) ||
            termsCoEfficientTable[0];
        }
        let cargoDetails = { ...operation.cargoDetails };

        if (index === 0) {
          const currentType = fleetFuelType.replace("TYPE", "");
          const {
            bnkDelhs = 0,
            bnkDells = 0,
            bnkDelmgo = 0,
            bnkPriceDeliveryhs = 0,
            bnkPriceDeliveryls = 0,
            bnkPriceDeliverymgo = 0,
          } = fleet;
          cargoDetails = {
            ...cargoDetails,
            bunkerSuppliedHSFO: bnkDelhs,
            bunkerSuppliedLSFO: bnkDells,
            bunkerSuppliedMGO: bnkDelmgo,
            [`fuelPriceType${currentType}Hsfo`]: bnkPriceDeliveryhs,
            [`fuelPriceType${currentType}Lsfo`]: bnkPriceDeliveryls,
            [`fuelPriceType${currentType}Mgo`]: bnkPriceDeliverymgo,
          };
        }
        return {
          ...operation,
          ...removeDistanceFromResultMap(selectedResultMap),
          cargoDetails,
          port: commencePort,
          terms: isTermExists.label,
          factor: isTermExists.value,
        };
      });

      if (!isPortDistanceChanged) {
        let portDistanceRes = currentState.portDistanceResponse;
        if (fetchPortDistance.current) {
          portDistanceRes = await onFetchAndSetIntitalPortDistance(updatedCalculatorData);
        }
        portOperation = addPortDistanceToOperations(portDistanceRes, [...portOperation]);
      }
      fleet = addPortDistanceToSelectedFleet(portOperation, fleet);

      if (changeVessel || !currentState.selectedVessels._id) {
        setSelectedVessels(fleet);
      }

      setCalculatorData({
        ...updatedCalculatorData,
        clientQuery: {
          ...updatedCalculatorData.clientQuery,
          fuelType: fleetFuelType,
        },
        fleetList: (updatedCalculatorData.fleetList || []).map((singleFleet) => {
          if (singleFleet._id === fleet._id) return fleet;
          else return singleFleet;
        }),
        portOperation,
      });
    },
    [onFetchAndSetIntitalPortDistance, setCalculatorData, setSelectedVessels]
  );

  const sendCalculationRequest = useCallback(
    async (sendData) => {
      const currentState = stateRef.current;
      let portDistanceRes =
        sendData?.portDistanceResponse || currentState.portDistanceResponse;
      let realData =
        sendData?.clientQuery?.portToPortDistanceReal?.output ||
        currentState.realPortDistanceResponse;
      let payload =
        sendData?.clientQuery?.portToPortDistanceReal?.payload ||
        currentState.portDistancePayloadResponse;

      if (fetchPortDistance.current) {
        const {
          data,
          realData: realDataRes,
          payload: payloadRes,
        } = await onFetchAndSetIntitalPortDistance(sendData);
        portDistanceRes = data;
        realData = realDataRes;
        payload = payloadRes;
      }

      sendData = {
        ...sendData,
        clientQuery: {
          ...sendData.clientQuery,
          portToPortDistanceReal: {
            output: realData,
            payload,
          },
          portToPortDistance: {
            output: portDistanceRes,
            payload,
          },
        },
        portOperation: addPortDistanceToOperations(
          portDistanceRes,
          [...(sendData.portOperation || [])],
          realData,
          false,
          sendData.reset || false
        ),
      };

      let fleetSelected = {};
      const updatedFleedIds = (sendData.fleetList || []).map((fleetDetails) => ({
        ...fleetDetails,
        vesselUniqueId: uuidv4(),
      }));

      let modifiedData = {
        cargoList: sendData.portOperation.filter((item) => !item.isExtra),
        cargoExtraDetails: sendData.portOperation.filter((item) => !!item.isExtra),
        fleetList: cloneDeep(updatedFleedIds),
        clientQuery: {
          ...sendData.clientQuery,
          calculationFormat: sendData.portOperation
            .map((item) => item._id)
            .join(","),
        },
        autoSave: false,
      };

      await calculationValidation(modifiedData, currentState.selectedVessels);

      setLoader(true, "Calculating pricing and costs...");
      const res = await sendCalculatorResponse(modifiedData);
      setLoader(false);

      const fleetData = fleetWithCalculatorDataMapping(
        cloneDeep(updatedFleedIds),
        res?.data
      );

      if (currentState.selectedVessels && currentState.selectedVessels._id) {
        fleetSelected =
          fleetData.find((item) => item._id === currentState.selectedVessels._id) || {};
      } else {
        fleetSelected = fleetData[0];
      }

      const updatedCalculatorData = {
        ...sendData,
        fleetList: fleetData,
        clientQuery: {
          ...sendData.clientQuery,
          calculationFormat: modifiedData.clientQuery.calculationFormat,
        },
      };

      setCalculatorData(updatedCalculatorData);
      onChangeFleetRowSelect(fleetSelected, updatedCalculatorData, true, true);

      const {
        __v,
        version,
        system,
        createdUser,
        vesselId,
        vesselName,
        userId,
        lastModifiedUser,
        lastModifiedDate,
        ...restClientQuery
      } = updatedCalculatorData.clientQuery;

      const newUpdatedQuery = {
        ...restClientQuery,
        cargoList: sendData.portOperation,
        createdUser: createdUser?._id,
      };

      const newUpdatedFleet = { ...fleetSelected };

      if (sendData.autoSave) {
        saveAllResultUpdatedData({
          newUpdatedQuery,
          newUpdatedFleet,
        });
      }
    },
    [
      onFetchAndSetIntitalPortDistance,
      sendCalculatorResponse,
      setCalculatorData,
      onChangeFleetRowSelect,
      saveAllResultUpdatedData,
      setLoader,
    ]
  );

  const getInitialData = useCallback(
    async (contractId) => {
      setLoader(true, "Fetching contract data...");
      getEstimateContractByIdApi({ id: contractId })
        .then(async (res) => {
          // vessel-vessel estimates (e.g. a Vessel-Vessel next trip) have their own page
          if (res?.data?.contractType === "vessel-vessel") {
            setLoader(false);
            history.replace(`/vessel-vessel-contract/${contractId}`);
            return;
          }
          setIsClosed(res.data.status === "close");
          setIsEditable(res.data.status === "open" && res.data.access === "private");
          setLoader(false);
          setRawEstimateContract(res?.data);

          const clientQueryPath = isViewOnly
            ? res.data?.cargoContractDetails?.operationCargoContract.cargoDetails
                ?.customerCargo ||
              res.data?.cargoContractDetails?.operationCargoContract.cargoDetails
            : res.data?.cargoContractDetails?.cargoDetails?.customerCargo ||
              res.data?.cargoContractDetails?.cargoDetails;

          const vesselQueryPath = isViewOnly
            ? res.data?.vesselContractDetails?.operationVesselContract.vesselDetails
            : res.data?.vesselContractDetails?.vesselDetails;

          const clientQuery = clientQueryPath;
          const calculatorResult = vesselQueryPath;
          const portOperation = clientQuery?.cargoList.map((item, index) => ({
            ...item,
            index,
          }));

          await sendCalculationRequest({
            portOperation: portOperation,
            fleetList: [calculatorResult],
            clientQuery: clientQuery,
            autoSave: false,
          });
          setIsInitialLoad(true);
        })
        .catch(() => {
          setLoader(false);
        })
        .finally(() => {
          setLoader(false);
        });
    },
    [isViewOnly, sendCalculationRequest, setLoader]
  );

  const onClickCalculateAndSave = useCallback(async () => {
    const currentState = stateRef.current;
    await sendCalculationRequest({ ...currentState.calculatorData, autoSave: true });
  }, [sendCalculationRequest]);

  useEffect(() => {
    if (isInitialLoad && new URLSearchParams(location?.search)?.get("code")) {
      onClickCalculateAndSave().then(() => {
        history.replace(`${location.pathname}`);
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isInitialLoad]);

  useEffect(() => {
    setIsFullScreen(true);
    if (id) {
      getInitialData(id);
    }
    return () => {
      setIsFullScreen(false);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const onUpdateAndSavePortDistance = useCallback(
    ({ updateData = {}, saveData = {}, updatedCalculatorData = {} }) => {
      setLoader(true, "Saving port distance details...");
      Promise.all([savePortDistanceApi(saveData)])
        .then(() => {
          setLoader(false);
          sendCalculationRequest(updatedCalculatorData);
        })
        .catch((err) => {
          setLoader(false);
          toastError(err?.data?.message || "Something went wrong.");
        });
    },
    [sendCalculationRequest, setLoader]
  );

  const delayUpdateAndSaveOperation = useCallback(
    _.debounce((data) => onUpdateAndSavePortDistance(data), 500),
    [onUpdateAndSavePortDistance]
  );

  const onFetchPortOperationDistance = useCallback(
    (
      reset = false,
      propCalculator = null,
      portCanalChecks = {},
      isSave = false
    ) => {
      const currentState = stateRef.current;
      let updatedCalculatorData = propCalculator || { ...currentState.calculatorData };
      const { getPortDistanceString, routeList } =
        convertPortOperationToDistanceString(updatedCalculatorData);
      const { clientQuery = {} } = updatedCalculatorData;
      const {
        eca = false,
        hra = false,
        jwc = false,
        suez = false,
        panama = false,
        singapore = false,
      } = clientQuery;
      const portDataObj = {
        eca,
        hra,
        jwc,
        suez,
        panama,
        singapore,
        routeOverride: false,
        routeList: routeList,
        portList: getPortDistanceString,
        contractId: id,
        getGeometry: false,
      };

      const request = reset
        ? resetPortDistanceForContractApi({ contractId: id })
        : updatePortDistanceForContractApi(portDataObj);

      if (!loader) setLoader(true, "Recalculating port distances...");
      request
        .then((res) => {
          setLoader(false);
          setPortDistanceResponse(res.data);
          setRealPortDistanceResponse(res?.realData);
          setPortDistancePayloadResponse(res?.payload);
          if (reset) {
            updatedCalculatorData = {
              ...updatedCalculatorData,
              clientQuery: {
                ...updatedCalculatorData.clientQuery,
                portToPortDistance: {
                  ...updatedCalculatorData.clientQuery.portToPortDistance,
                  output: res.data,
                },
              },
            };
          }
          let realData = reset
            ? JSON.parse(JSON.stringify(res.data))
            : res.realData;
          const newPortOperations = addPortDistanceToOperations(
            res.data,
            [...(updatedCalculatorData.portOperation || [])],
            realData,
            false,
            reset
          );
          sendCalculationRequest({
            ...updatedCalculatorData,
            reset,
            clientQuery: {
              ...updatedCalculatorData.clientQuery,
              portToPortDistanceReal: {
                payload: res.payload,
                output: realData,
              },
              portToPortDistance: {
                payload: res.payload,
                output: res.data,
              },
            },
            portOperation: newPortOperations,
            portDistanceResponse: res.data,
            autoSave: isSave,
          });
        })
        .catch(() => setLoader(false));
    },
    [
      id,
      loader,
      sendCalculationRequest,
      setLoader,
      setPortDistancePayloadResponse,
      setPortDistanceResponse,
      setRealPortDistanceResponse,
    ]
  );

  const onChangeSelectedVessel = useCallback(
    (e, isFleetEdit = false) => {
      const {
        name = "",
        value = "",
        type = "number",
        checked = false,
      } = e.target || {};
      const currentState = stateRef.current;
      let newUpdatedFleet = { ...currentState.selectedVessels };
      const { fuelType = "" } = currentState.calculatorData.clientQuery || {};
      let updatedvessel = { ...JSON.parse(newUpdatedFleet.vessel || "{}") };

      if (isFleetEdit) {
        newUpdatedFleet[name] = value;
      } else {
        if (type === "checkbox") {
          updatedvessel[name] = checked;
          if (
            name === "vesselBalComb1Selected" ||
            name === "vesselBalComb2Selected" ||
            name === "vesselBalComb3Selected" ||
            name === "vesselBalComb4Selected"
          ) {
            if (
              !updatedvessel["vesselBalComb1Selected"] &&
              !updatedvessel["vesselBalComb2Selected"] &&
              !updatedvessel["vesselBalComb3Selected"] &&
              !updatedvessel["vesselBalComb4Selected"]
            ) {
              return;
            }
          } else if (
            name === "vesselLadComb1Selected" ||
            name === "vesselLadComb2Selected" ||
            name === "vesselLadComb3Selected" ||
            name === "vesselLadComb4Selected"
          ) {
            if (
              !updatedvessel["vesselLadComb1Selected"] &&
              !updatedvessel["vesselLadComb2Selected"] &&
              !updatedvessel["vesselLadComb3Selected"] &&
              !updatedvessel["vesselLadComb4Selected"]
            ) {
              return;
            }
          }
        } else {
          updatedvessel[name] = value;
        }
      }
      const updatedFleet = {
        ...newUpdatedFleet,
        vessel: JSON.stringify(updatedvessel),
      };
      setSelectedVessels(updatedFleet);

      const updatedFleetList = (currentState.calculatorData.fleetList || []).map(
        (item) => {
          if (item._id === updatedFleet._id) {
            return updatedFleet;
          }
          return item;
        }
      );
      let updatedPortOperation = [...(currentState.calculatorData.portOperation || [])];
      if (
        name === "bnkPriceDeliveryhs" ||
        name === "bnkPriceDeliveryls" ||
        name === "bnkPriceDeliverymgo"
      ) {
        const currentType = fuelType.replace("TYPE", "");
        if (name === "bnkPriceDeliveryhs")
          updatedPortOperation[0].cargoDetails[
            `fuelPriceType${currentType}Hsfo`
          ] = value;
        if (name === "bnkPriceDeliveryls")
          updatedPortOperation[0].cargoDetails[
            `fuelPriceType${currentType}Lsfo`
          ] = value;
        if (name === "bnkPriceDeliverymgo")
          updatedPortOperation[0].cargoDetails[
            `fuelPriceType${currentType}Mgo`
          ] = value;
      }
      if (name === "bnkDelhs" || name === "bnkDells" || name === "bnkDelmgo") {
        if (updatedPortOperation.length) {
          if (name === "bnkDelhs")
            updatedPortOperation[0].cargoDetails.bunkerSuppliedHSFO = value;
          if (name === "bnkDells")
            updatedPortOperation[0].cargoDetails.bunkerSuppliedLSFO = value;
          if (name === "bnkDelmgo")
            updatedPortOperation[0].cargoDetails.bunkerSuppliedMGO = value;
        }
      }
      setCalculatorData({
        ...currentState.calculatorData,
        portOperation: updatedPortOperation,
        fleetList: updatedFleetList,
      });
    },
    [setCalculatorData, setSelectedVessels]
  );

  const onChangeBunkerScrubber = useCallback(
    (index, e) => {
      const { name = "", value = "" } = e.target;
      const currentState = stateRef.current;
      let newPortOperation = [...(currentState.calculatorData?.portOperation || [])];
      newPortOperation[index].cargoDetails[name] = Number(value);
      setCalculatorData({ ...currentState.calculatorData, portOperation: newPortOperation });
    },
    [setCalculatorData]
  );

  const onChangeSyncBunker = useCallback(
    (checked) => {
      const currentState = stateRef.current;
      let updatedClientQuery = { ...currentState.calculatorData.clientQuery };

      setSyncBunker(checked);
      let updatedCalculatorData = { ...currentState.calculatorData };

      let clientQuery = {
        ...updatedCalculatorData.clientQuery,
        fuelPriceOverridden: checked,
        fuelCalculationMethod:
          !updatedCalculatorData.clientQuery.fuelCalculationMethod || updatedCalculatorData.clientQuery.fuelCalculationMethod === "DEFAULT"
            ? "LIFO"
            : updatedCalculatorData.clientQuery.fuelCalculationMethod,
      };
      if (!checked) {
        clientQuery = {
          ...updatedCalculatorData.clientQuery,
          fuelPriceOverridden: checked,
          fuelCalculationMethod: "DEFAULT",
        };
      }

      updatedCalculatorData = {
        ...updatedCalculatorData,
        clientQuery,
      };
      setCalculatorData(updatedCalculatorData);
    },
    [setCalculatorData, setSyncBunker]
  );

  const onChangeSplitHire = useCallback(
    (index, e, isDelete = false) => {
      const currentState = stateRef.current;
      const fleetItem = currentState.calculatorData.fleetList?.[0];
      const splitHireArray = fleetItem?.splitHire
        ? JSON.parse(fleetItem.splitHire)
        : [{ hireRate: "", NoDays: "" }];

      let updatedSplitHire = [...splitHireArray];
      if (isDelete) {
        updatedSplitHire = updatedSplitHire.filter((_, i) => i !== index);
      } else {
        const { name, value } = e.target;
        updatedSplitHire[index][name] = value;
      }

      setCalculatorData({
        ...currentState.calculatorData,
        fleetList: (currentState.calculatorData.fleetList || []).map((item, i) =>
          i === 0
            ? { ...item, splitHire: JSON.stringify(updatedSplitHire) }
            : item
        ),
      });
    },
    [setCalculatorData]
  );

  const addRow = useCallback(() => {
    const currentState = stateRef.current;
    const fleetItem = currentState.calculatorData.fleetList?.[0];
    const splitHireArray = fleetItem?.splitHire
      ? JSON.parse(fleetItem.splitHire)
      : [{ hireRate: "", NoDays: "" }];
    const newRow = { hireRate: "", NoDays: "", applied: 0, disable: false };

    setCalculatorData({
      ...currentState.calculatorData,
      fleetList: (currentState.calculatorData.fleetList || []).map((item, i) =>
        i === 0
          ? {
              ...item,
              splitHire: JSON.stringify([...splitHireArray, newRow]),
            }
          : item
      ),
    });
  }, [setCalculatorData]);

  const onDeleteOperations = useCallback(
    (index, cid, opIndex) => {
      setLoader(true, "Deleting operation...");
      fetchPortDistance.current = true;
      const currentState = stateRef.current;

      deleteCargoFromEstimateByIdApi({
        contractId: id,
        cargoId: opIndex,
        contractType: rawEstimateContract?.cargoContractDetails?.contractType,
      })
        .then((res) => {
          setLoader(false);
          let portOperation = [...(currentState.calculatorData.portOperation || [])];
          portOperation.splice(index, 1);
          const updatedSelectedQuery = {
            ...currentState.calculatorData?.clientQuery,
            calculationFormat: res.data?.cargoContractDetails?.calculationFormat,
          };

          setCalculatorData({
            ...currentState.calculatorData,
            portOperation,
            clientQuery: updatedSelectedQuery,
          });
        })
        .catch(() => setLoader(false));
    },
    [id, rawEstimateContract, setCalculatorData, setLoader]
  );

  const onAddOperations = useCallback(
    (requiredData = {}) => {
      setLoader(true, "Adding new operation...");
      fetchPortDistance.current = true;
      const currentState = stateRef.current;

      addCargoForEstimateApi({
        details: {
          ...initialCreatePortOperation,
          ...requiredData,
        },
        contractId: id,
        addIndex: openAddOperationIndex,
      })
        .then((response) => {
          const updatedSelectedQuery = {
            ...currentState.calculatorData.clientQuery,
            calculationFormat: response.data?.calculationFormat,
          };
          setLoader(false);

          const newPortOp = placeAddedOperation(
            currentState.calculatorData.portOperation,
            response?.data?.cargoDetails?.cargoList ||
              response?.data?.cargoDetails?.customerCargo?.cargoList ||
              [],
            openAddOperationIndex
          );

          const updatedCalculatorData = {
            ...currentState.calculatorData,
            clientQuery: updatedSelectedQuery,
            portOperation: newPortOp,
          };

          setCalculatorData(updatedCalculatorData);
          sendCalculationRequest(updatedCalculatorData);
        })
        .catch(() => {
          setLoader(false);
        });
    },
    [id, openAddOperationIndex, sendCalculationRequest, setCalculatorData, setLoader]
  );

  const onChangePortOperations = useCallback(
    (index, e, cargoUpdate = false) => {
      let { value = "", name = "" } = e.target;
      const currentState = stateRef.current;
      let portOperation = [...(currentState.calculatorData.portOperation || [])];

      if (name === "terms") {
        const termFactor = termsCoEfficientTable.find((item) => item.label === value);
        portOperation[index]["terms"] = value;
        portOperation[index]["factor"] = (termFactor && termFactor.value) || 0;
      } else if (cargoUpdate) {
        if (!portOperation[index].cargoDetails) {
          portOperation[index].cargoDetails = {};
        }
        portOperation[index].cargoDetails[name] = value;
      } else {
        portOperation[index][name] = value;
      }

      let updatedCalculatorData = {
        ...currentState.calculatorData,
        portOperation,
      };

      if (
        !cargoUpdate &&
        updatedCalculatorData?.clientQuery?.portToPortDistance?.output &&
        portOperation[index - 1] &&
        portOperation[index]?.port
      ) {
        const key = `${portOperation[index - 1]?.port}_${portOperation[index].port}`;
        if (updatedCalculatorData.clientQuery.portToPortDistance.output[key]) {
          updatedCalculatorData.clientQuery.portToPortDistance.output[key][name] =
            value;
        }
      }

      if (name === "distanceNormal" || name === "distanceECA") {
        const updateData = {
          distEca: portOperation[index].distanceECA,
          distNormal: portOperation[index].distanceNormal,
          id: portOperation[index]._id,
        };
        const saveData = {
          distEca: portOperation[index].distanceECA,
          distNormal: portOperation[index].distanceNormal,
          openingPort:
            (portOperation[index - 1] && portOperation[index - 1]["port"]) || "",
          endingPort: portOperation[index]["port"] || "",
        };
        delayUpdateAndSaveOperation({
          updateData,
          saveData,
          updatedCalculatorData,
        });
      }
      setCalculatorData(updatedCalculatorData);
    },
    [delayUpdateAndSaveOperation, setCalculatorData]
  );

  const calculationErrors = useMemo(() => {
    let errors = [];
    if (
      selectedVessels &&
      calculatorData.portOperation.length &&
      calculatorData.fleetList.length
    ) {
      errors = calculationValidation(calculatorData, selectedVessels);
    }
    return errors;
  }, [calculatorData, selectedVessels]);

  const onClickCalculate = useCallback(() => {
    const currentState = stateRef.current;
    sendCalculationRequest({ ...currentState.calculatorData, autoSave: false });
  }, [sendCalculationRequest]);

  const onSetOpenMap = useCallback(() => {
    const currentState = stateRef.current;
    if (id) {
      window.open(`/map/${currentState.calculatorData.clientQuery?._id}`);
    }
  }, [id]);

  const onClickCopyToEstimate = useCallback(() => {
    setEstimationCopyModelOpen(true);
  }, []);

  const handleCopyToEstimation = useCallback(() => {
    setLoader(true, "Copying estimation...");
    const { _id, userId, access, createdAt, contractName, updateAt, ...rest } =
      rawEstimateContract;
    const payload = {
      contractName: inputValue,
      ...rest,
    };
    createEstimateContractApi(payload)
      .then(() => {
        setLoader(false);
        toastSuccess("Estimation copied Successfully");
        setEstimationCopyModelOpen(false);
      })
      .catch(() => {
        setLoader(false);
        toastError("Failed to copy estimation to estimate contract");
      });
  }, [inputValue, rawEstimateContract, setLoader]);

  const onClickEditCargoContract = useCallback(() => {
    setEditCargoContractModelOpen(true);
    const currentState = stateRef.current;
    const data = rawEstimateContract?.cargoContractDetails;
    const cargoList =
      data?.cargoDetails?.cargoList ||
      data?.cargoDetails?.customerCargo?.cargoList ||
      data?.operationCargoContract?.cargoDetails?.customerCargo?.cargoList ||
      data?.operationCargoContract?.cargoDetails?.cargoList ||
      currentState.calculatorData?.portOperation ||
      [];
    setCargoFormData({ ...data, cargoList });
    setPrevAttachments({
      attachments: [...(data?.attachments || [])],
      textContract: data?.textContract,
    });
  }, [rawEstimateContract]);

  const onClickVesselCargoContract = useCallback(() => {
    setEditVesselContractModelOpen(true);
    const data = rawEstimateContract?.vesselContractDetails;
    setVesselFormData(data);
    setPrevAttachments({
      attachments: [...(data?.attachments || [])],
      textContract: data?.textContract,
    });
  }, [rawEstimateContract]);

  const handleUpdateCargoContract = useCallback(() => {
    const { _id, cargoList, ...payload } = cargoFormData;
    const finalPayload = {
      ...payload,
      cargoDetails: {
        ...payload.cargoDetails,
        cargoList: cargoList,
      },
    };
    if (!payload.contractName) {
      toastError("Contract name is required.");
      return;
    }
    const formPayload = new FormData();

    if (cargoTextContract) {
      const fileType = cargoTextContract.type || "application/octet-stream";
      const fileName = cargoTextContract.name || "contract";

      const textBlob = new Blob([cargoTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    if (cargoAttachments?.length) {
      cargoAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    formPayload.append(
      "data",
      JSON.stringify({
        ...finalPayload,
        isContract: true,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    setLoader(true, "Updating cargo contract...");
    updateEstimateCargoApi({ _id: id }, formPayload)
      .then(() => {
        setLoader(false);
        setEditCargoContractModelOpen(false);
        setCargoAttachments([]);
        setCargoTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        getInitialData(id);
        toastSuccess("Cargo Contract Updated successfully!!");
      })
      .catch((err) => {
        setLoader(false);
        toastError(err.message);
      });
  }, [
    cargoAttachments,
    cargoFormData,
    cargoTextContract,
    getInitialData,
    id,
    organizationId,
    prevAttachments,
    setLoader,
  ]);

  const removeCargoAttachment = useCallback((index) => {
    setCargoAttachments((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleCargoContractInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setCargoFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleCargoTextContractUpload = useCallback((e) => {
    if (e.target.files[0]) {
      setCargoTextContract(e.target.files[0]);
    }
  }, []);

  const handleCargoContractAttachmentUpload = useCallback((e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter((file) => file.size <= 5 * 1024 * 1024);
      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }
      setCargoAttachments((prev) => [...prev, ...validFiles]);
    }
  }, []);

  const handleUpdateVesselContract = useCallback(() => {
    const { _id, ...payload } = vesselFormData;
    if (!payload.contractName) {
      toastError("Contract name is required.");
      return;
    }
    const formPayload = new FormData();

    if (vesselTextContract) {
      const fileType = vesselTextContract.type || "application/octet-stream";
      const fileName = vesselTextContract.name || "contract";

      const textBlob = new Blob([vesselTextContract], { type: fileType });
      const textFile = new File([textBlob], fileName, { type: fileType });

      formPayload.append("files", textFile);
      formPayload.append(
        "textContractMetadata",
        JSON.stringify({ fileType: "textContract" })
      );
    }

    if (vesselAttachments?.length) {
      vesselAttachments.forEach((file) => {
        formPayload.append("files", file);
      });
    }

    formPayload.append(
      "data",
      JSON.stringify({
        ...payload,
        attachments: prevAttachments.attachments,
        textContract: prevAttachments.textContract,
        organizationId,
      })
    );

    setLoader(true, "Updating vessel contract...");
    updateVesselContractApi({ _id }, formPayload)
      .then(() => {
        setLoader(false);
        setEditVesselContractModelOpen(false);
        setVesselAttachments([]);
        setVesselTextContract("");
        setPrevAttachments({
          attachments: [],
          textContract: "",
        });
        getInitialData(id);
        toastSuccess("Vessel Contract Updated successfully!!");
      })
      .catch((err) => {
        setLoader(false);
        toastError(err.message);
      });
  }, [
    getInitialData,
    id,
    organizationId,
    prevAttachments,
    setLoader,
    vesselAttachments,
    vesselFormData,
    vesselTextContract,
  ]);

  const removeVesselAttachment = useCallback((index) => {
    setVesselAttachments((prev) => prev.filter((_, i) => i !== index));
  }, []);

  const handleVesselContractInputChange = useCallback((e) => {
    const { name, value } = e.target;
    setVesselFormData((prev) => ({ ...prev, [name]: value }));
  }, []);

  const handleVesselTextContractUpload = useCallback((e) => {
    if (e.target.files[0]) {
      setVesselTextContract(e.target.files[0]);
    }
  }, []);

  const handleVesselContractAttachmentUpload = useCallback((e) => {
    if (e.target.files) {
      const newFiles = Array.from(e.target.files);
      const validFiles = newFiles.filter((file) => file.size <= 5 * 1024 * 1024);
      if (validFiles.length !== newFiles.length) {
        alert("Some files exceed the 5 MB size limit and were not added.");
      }
      setVesselAttachments((prev) => [...prev, ...validFiles]);
    }
  }, []);

  return {
    id,
    isViewOnly,
    calculatorData,
    setCalculatorData,
    selectedVessels,
    setSelectedVessels,
    syncBunker,
    setSyncBunker,
    isOverride,
    setIsOverride,
    rawEstimateContract,
    cargoFormData,
    setCargoFormData,
    vesselFormData,
    setVesselFormData,
    prevAttachments,
    setPrevAttachments,
    cargoTextContract,
    setCargoTextContract,
    vesselTextContract,
    setVesselTextContract,
    cargoAttachments,
    setCargoAttachments,
    vesselAttachments,
    setVesselAttachments,
    inputValue,
    setInputValue,
    estimationCopyModelOpen,
    setEstimationCopyModelOpen,
    editCargoContractModelOpen,
    setEditCargoContractModelOpen,
    editVesselContractModelOpen,
    setEditVesselContractModelOpen,
    supplyModal,
    setSupplyModal,
    openAddOperation,
    setOpenAddOperation,
    splitHireModal,
    setSplitHireModal,
    showExpensesModal,
    setShowExpensesModal,
    openAddOperationIndex,
    setOpenAddOperationindex,
    IsEditable,
    isClosed,
    activeTab,
    setActiveTab,
    fleetCheckbox,
    setFleetCheckbox,
    swipeableActions,

    // Handlers
    getInitialData,
    handleTabChange,
    handleSwipeChange,
    onChangeClientQuery,
    onChangeSelectedVessel,
    onChangeFleetRowSelect,
    onChangePortOperations,
    onChangeBunkerScrubber,
    onChangeSyncBunker,
    onChangeSplitHire,
    addRow,
    onDeleteOperations,
    onAddOperations,
    onClickCalculate,
    onClickCalculateAndSave,
    sendCalculationRequest,
    onFetchPortOperationDistance,
    onSetOpenMap,
    onClickCopyToEstimate,
    handleCopyToEstimation,
    onClickEditCargoContract,
    onClickVesselCargoContract,
    handleUpdateCargoContract,
    handleUpdateVesselContract,
    removeCargoAttachment,
    handleCargoContractInputChange,
    handleCargoTextContractUpload,
    handleCargoContractAttachmentUpload,
    removeVesselAttachment,
    handleVesselContractInputChange,
    handleVesselTextContractUpload,
    handleVesselContractAttachmentUpload,
    calculationErrors,
  };
}
